import React, { FC } from 'react';
import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import Specialist from '../../model/Specialist';
import { QUERIES } from '../../styles/breakpoint';

const TextSectionContainer = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 15px;
`;

// eslint-disable-next-line no-unused-vars
const SpecialistProfile: FC<{specialist: Specialist}> = ({ specialist }) => {
  const {
    firstName,
    lastName,
  } = specialist;
  const isMobile = useMediaQuery({ query: QUERIES.mobile });
  return (
    <TextSectionContainer>
      <Typography.Title style={{ fontSize: isMobile ? '24px' : '28px', fontWeight: 400, marginBottom: 0 }}>
        {`${firstName} ${lastName}`}
      </Typography.Title>
      <Typography.Text style={{ fontWeight: 300, fontSize: isMobile ? '16px' : '18px' }}>
        General Psychologist
      </Typography.Text>
    </TextSectionContainer>
  );
};

export default SpecialistProfile;
